var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import RadioImageButton from '@declaration/components/UI/RadioImageButton.vue';
import { GLASS_DAMAGE_TYPE_IMAGE_CHOICES, GLASS_DAMAGE_TYPE_PLAIN_CHOICES, } from '@declaration/constants/glassDamageConstants';
const glassDamage = namespace('glassDamage');
let DamageTypeComponent = class DamageTypeComponent extends Vue {
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get glassDamage() {
        return this.change.data;
    }
    get glassDamageTypeImageChoices() {
        return GLASS_DAMAGE_TYPE_IMAGE_CHOICES;
    }
    get glassDamageTypeButtonChoices() {
        return GLASS_DAMAGE_TYPE_PLAIN_CHOICES;
    }
    onChange(type) {
        this.updateGlassDamage({
            changeKey: this.changeKey,
            data: {
                type: this.glassDamage.type === type ? null : type,
            },
        });
    }
};
__decorate([
    glassDamage.Getter('change')
], DamageTypeComponent.prototype, "changeGetter", void 0);
__decorate([
    glassDamage.Getter('validation')
], DamageTypeComponent.prototype, "validationGetter", void 0);
__decorate([
    glassDamage.Action('updateDamage')
], DamageTypeComponent.prototype, "updateGlassDamage", void 0);
DamageTypeComponent = __decorate([
    Component({
        components: {
            RadioPrimaryButton,
            RadioImageButton,
        },
        props: {
            changeKey: { type: [Number, String], default: null },
        },
    })
], DamageTypeComponent);
export default DamageTypeComponent;
